"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _HeaderWithFilterComponent = _interopRequireDefault(require("./HeaderWithFilterComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formSelector = (0, _reduxForm.formValueSelector)('order-history-filter');
var mapStateToProps = function mapStateToProps(state) {
  var startDate = formSelector(state, 'startDate');
  return {
    startDate: startDate
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearDate: function clearDate(fieldName) {
      return dispatch((0, _reduxForm.change)('order-history-filter', fieldName, null));
    }
  };
};
var HeaderWithFilterContainerForm = (0, _reduxForm.reduxForm)({
  form: 'order-history-filter',
  initialValues: {
    startDate: undefined,
    endDate: undefined
  }
})(_HeaderWithFilterComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HeaderWithFilterContainerForm);